class DownloadTrackerStatusUpdateModel {
    constructor(id, status, userId) {
      this.id = id;
      this.status = status;
      this.userId = userId;
    }
  }
  
  export default DownloadTrackerStatusUpdateModel;